import { imageUrl, type TreatmentSection } from "@/lib/treatments";

// Renders the `sections` array of a treatments entry. The markup mirrors what
// the original PHP pages used (h3 + <hr> + copy, and the col-lg-5 / col-lg-7
// split for image-beside-text) so style.css applies unchanged.

function Body({ section }: { section: TreatmentSection }) {
  return (
    <>
      {section.paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
      {section.items.length > 0 && (
        <ul>
          {section.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )}
    </>
  );
}

function Section({ section }: { section: TreatmentSection }) {
  if (section.type === "html") {
    return <div dangerouslySetInnerHTML={{ __html: section.html }} />;
  }

  if (section.type === "imageText") {
    const image = (
      <div className="col-lg-5" style={{ paddingTop: 38 }}>
        <img src={imageUrl(section.image)} alt={section.image.alt_text || section.heading} />
      </div>
    );
    const text = (
      <div className="col-lg-7">
        <div className="service-details-inner">
          <h3>{section.heading}</h3>
          <hr />
          <Body section={section} />
        </div>
      </div>
    );
    return (
      <div className="row align-items-center">
        {section.imageSide === "left" ? (
          <>
            {image}
            {text}
          </>
        ) : (
          <>
            {text}
            {image}
          </>
        )}
      </div>
    );
  }

  return (
    <div className="col-md-12 custom-pt-38 px-4">
      <h3>{section.heading}</h3>
      <hr />
      <Body section={section} />
    </div>
  );
}

export default function TreatmentSections({ sections }: { sections: TreatmentSection[] }) {
  return (
    <>
      {sections.map((section, i) => (
        <Section key={`${section.heading}-${i}`} section={section} />
      ))}
    </>
  );
}
